import { UserImage } from "../UserImage";

interface User {
  /** User name */
  name: string;
  /** User image URL */
  src: string;
}

export interface TwoUserStackProps {
  /** Whether to use full rounded border-radius */
  isFullRounded?: boolean;
  /** User tuple */
  users: [User, User];
}

/**
 * Displays an diagonal stack of two `UserImage` components. They have their
 * borders enabled by default with a `border-inherit` class, so you can control
 * the border color by wrapping the component with a div containing a
 * `border-*` class.
 */
export const TwoUserStack = ({
  isFullRounded = false,
  users,
}: TwoUserStackProps) => {
  const [user1, user2] = users;
  return (
    <div className="inline-flex flex-col border-inherit">
      <div className="flex border-inherit">
        <UserImage
          hasBorder
          isFullRounded={isFullRounded}
          name={user1.name}
          size="6"
          src={user1.src}
        />
      </div>
      <div className="-mt-5 ml-2 flex border-inherit">
        <UserImage
          hasBorder
          isFullRounded={isFullRounded}
          name={user2.name}
          size="6"
          src={user2.src}
        />
      </div>
    </div>
  );
};

TwoUserStack.displayName = "TwoUserStack";
